module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-general notification is-success-light has-text-left",
    class: {
      'mb-10': _vm.paddingBottom,
      'mb-0': !_vm.paddingBottom
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "mt-10"
  }, [_vm._m(1), _c('p', {
    staticClass: "small-content"
  }, [_c('span', [_vm._v("Apply to our ")]), _c('router-link', {
    attrs: {
      "to": '/referrals#content-creator'
    }
  }, [_vm._v(" Custom Referral Code ")]), _c('span', [_vm._v("program to get better benefits and more rewards.")])], 1), _c('p', {
    staticClass: "small-content"
  }, [_vm._v("Join now!")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-16"
  }, [_c('b', [_vm._v("Are you a content creator?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small-content"
  }, [_c('span', [_vm._v("Get an easy to remember referral code to use on your social networks!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eab5389","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_content_creator_link.vue
// module id = 357
// module chunks = 1